import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "pa-4" }
const _hoisted_2 = { class: "text-caption text-white" }

import { ref, onMounted, onUnmounted, computed } from "vue";
import { appBarMobileStore } from "@/stores/appBarMobile";


export default /*@__PURE__*/_defineComponent({
  __name: 'SchedulerSidebar',
  setup(__props) {

const appBarMobile = appBarMobileStore();
const showNav = ref(true);

// Required to make the router-view reload when user clicks the link again
const randomKey = ref("");
function updateRandom() {
  if (appBarMobile.showMenuIcon) {
    appBarMobile.showMenu = false;
    showNav.value = false;
  }
  randomKey.value = (Math.random() + 1).toString(36).substring(7);
}

// Timer for next execution
const currentTime = ref(new Date());
let timeInterval: number;

const timeUntilNext = computed(() => {
  const now = currentTime.value;
  const minutes = now.getMinutes();
  const seconds = now.getSeconds();

  // Calculate minutes until next 15-minute interval
  const nextInterval = Math.ceil((minutes + 1) / 15) * 15;
  const minutesUntil = (nextInterval - minutes) % 15 || 15;
  const secondsUntil = 60 - seconds;

  if (minutesUntil === 15 && secondsUntil === 60) {
    return "starting now...";
  }

  if (minutesUntil > 1) {
    return `${minutesUntil - 1}m ${secondsUntil}s`;
  } else {
    return `${secondsUntil}s`;
  }
});

onMounted(() => {
  // Handle mobile responsive behavior
  if (appBarMobile.showMenuIcon) {
    showNav.value = false;
  }

  // Update timer every second
  timeInterval = setInterval(() => {
    currentTime.value = new Date();
  }, 1000);
});

onUnmounted(() => {
  if (timeInterval) {
    clearInterval(timeInterval);
  }
});

return (_ctx: any,_cache: any) => {
  const _component_v_app_bar_nav_icon = _resolveComponent("v-app-bar-nav-icon")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item_subtitle = _resolveComponent("v-list-item-subtitle")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_navigation_drawer = _resolveComponent("v-navigation-drawer")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_main = _resolveComponent("v-main")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_unref(appBarMobile).showMenuIcon)
      ? (_openBlock(), _createBlock(_component_v_app_bar_nav_icon, {
          key: 0,
          onClick: _cache[0] || (_cache[0] = ($event: any) => (showNav.value = !showNav.value))
        }))
      : _createCommentVNode("", true),
    _createVNode(_component_v_navigation_drawer, {
      modelValue: showNav.value,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((showNav).value = $event)),
      permanent: !_unref(appBarMobile).showMenuIcon,
      temporary: _unref(appBarMobile).showMenuIcon,
      theme: "jigsawDark",
      width: "280"
    }, {
      append: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_component_v_card, {
            variant: "outlined",
            color: "rgba(255,255,255,0.1)"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_card_text, { class: "text-center" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_icon, {
                    size: "24",
                    class: "mb-2",
                    color: "orange"
                  }, {
                    default: _withCtx(() => _cache[6] || (_cache[6] = [
                      _createTextVNode("mdi-information")
                    ])),
                    _: 1
                  }),
                  _cache[7] || (_cache[7] = _createElementVNode("div", { class: "text-caption text-white" }, " Jobs run automatically every 15 minutes ", -1)),
                  _createElementVNode("div", _hoisted_2, " Next execution cycle in " + _toDisplayString(timeUntilNext.value), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_v_list_item, { class: "pa-4" }, {
          prepend: _withCtx(() => [
            _createVNode(_component_v_icon, {
              size: "32",
              color: "orange"
            }, {
              default: _withCtx(() => _cache[3] || (_cache[3] = [
                _createTextVNode("mdi-clock-outline")
              ])),
              _: 1
            })
          ]),
          default: _withCtx(() => [
            _createVNode(_component_v_list_item_title, { class: "text-h6 font-weight-bold" }, {
              default: _withCtx(() => _cache[4] || (_cache[4] = [
                _createTextVNode(" Scheduler ")
              ])),
              _: 1
            }),
            _createVNode(_component_v_list_item_subtitle, { class: "text-caption" }, {
              default: _withCtx(() => _cache[5] || (_cache[5] = [
                _createTextVNode(" Device Group Automation ")
              ])),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_v_divider),
        _createVNode(_component_v_list, {
          density: "comfortable",
          nav: ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_list_item, {
              "prepend-icon": "mdi-calendar-clock",
              title: "Device Groups",
              subtitle: "Manage scheduled commands",
              active: _ctx.$route.name === 'DeviceGroupScheduler',
              onClick: _cache[1] || (_cache[1] = ($event: any) => {
            _ctx.$router.push({ name: 'DeviceGroupScheduler' });
            updateRandom();
          })
            }, null, 8, ["active"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue", "permanent", "temporary"]),
    _createVNode(_component_v_main, null, {
      default: _withCtx(() => [
        _createVNode(_component_v_container, {
          fluid: "",
          class: "pa-0 ma-0"
        }, {
          default: _withCtx(() => [
            (_openBlock(), _createBlock(_component_router_view, { key: randomKey.value }))
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}
}

})